import {
  Children,
  Fragment,
  ReactNode,
  cloneElement,
  isValidElement,
} from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { IArticleConfig } from "./types";

type TArticleProps = IArticleConfig & {
  articleNo: number;
};

const flattenChildren = (children: ReactNode): ReactNode[] => {
  const result: ReactNode[] = [];
  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === Fragment) {
      result.push(
        ...flattenChildren((child.props as { children: ReactNode }).children)
      );
    } else {
      result.push(child);
    }
  });
  return result;
};

const isSubsection = (child: ReactNode): boolean =>
  isValidElement(child) &&
  (child.type as { __isLegalNoticeSubsection?: boolean })
    ?.__isLegalNoticeSubsection === true;

export const Article = ({ articleNo, title, content }: TArticleProps) => {
  const flat = flattenChildren(content);
  let subIdx = 0;
  const numbered = flat.map((child, i) => {
    if (isSubsection(child) && isValidElement(child)) {
      subIdx += 1;
      return cloneElement(child as React.ReactElement, {
        key: i,
        number: `${articleNo}.${subIdx}`,
      });
    }
    return <Fragment key={i}>{child}</Fragment>;
  });

  return (
    <Box>
      <Typography
        variant="h4"
        color="primary"
        textAlign="center"
        mb={1}
        sx={{
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {articleNo}. {title.toUpperCase()}
      </Typography>
      <Box mt={3} display="flex" flexDirection="column" gap={2}>
        {numbered}
      </Box>
    </Box>
  );
};
